(function() {

	angular
		.module('ngmvac')
		.filter('boardFilter', BoardFilter);

	function BoardFilter() {

		return function(arr, boards) {

			var applyFilter = false;

			angular.forEach( boards, function(board) {
				if( board.checked == true ) {
					applyFilter = true;
				}
			});

			if( applyFilter ) {
				var arrRes = [];

				angular.forEach(arr, function(hotel, index) {
					var clHotel = {};
					for( property in hotel ) {
						clHotel[property] = hotel[property];
					}
					clHotel.packageGrouped = [];

					angular.forEach(hotel.packageGrouped, function(group, indexGroup) {
						angular.forEach(boards, function(board, indexBoard) {
							if( board.boardCode == group[0].boardCode ) {
								if(board.checked) {
									clHotel.packageGrouped.push(group);
								}
							}

						});
					});

					if( clHotel.packageGrouped.length > 0 ) {
						arrRes.push(clHotel);
					}
				});

				return arrRes;
			}

			return arr;

		}
	}

})();